import { useEffect, useState } from "react";

import { Button } from "src/components/buttons";
import { ApiError } from "src/core/apiError";

import {
  BaseCandidate,
  CandidateChangesDrawer
} from "./candidateChangesDrawer";

import "./previewChanges.scss";

interface PreviewChangesDrawerProps<T extends BaseCandidate> {
  readonly onClose: () => void;
  readonly fetchCandidates: () => Promise<T[] | undefined>;
  readonly onReviewClick: () => void;
  readonly contextId?: string;
}

export const PreviewChangesDrawer = <T extends BaseCandidate>({
  onClose,
  fetchCandidates,
  onReviewClick,
  contextId
}: PreviewChangesDrawerProps<T>) => {
  const [candidate, setCandidate] = useState<T | undefined>();
  const [candidateLoading, setCandidateLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | undefined>();

  useEffect(() => {
    /**
     * Loads all the pending transactions.
     * there should just be one with a bunch of
     * events
     */
    if (contextId) {
      setCandidateLoading(true);
      fetchCandidates()
        .then((candidates: T[] = []) => {
          if (candidates[0]) {
            setCandidate(candidates[0]);
          }
        }, setError)
        .finally(() => {
          setCandidateLoading(false);
        });
    }
  }, [contextId, fetchCandidates]);

  return (
    <CandidateChangesDrawer
      title="Preview changes"
      onClose={onClose}
      candidate={candidate}
      error={error}
      isOpen={true}
      loading={candidateLoading}
    >
      <Button name="review-config" kind="primary" onClick={onReviewClick}>
        Review configuration
      </Button>
    </CandidateChangesDrawer>
  );
};
